import React from 'react'

export default function Footer() {
    return (
      <div className="footer-wrapper">
        <h5 className="footer">CD Project ( 3170710 ) </h5>
      </div>
    );
}
